import { useNavigate, useRouteError } from 'react-router';

import { Button } from '@/components/ui/button';

export function ErrorBoundary() {
  const error = useRouteError() as Error;
  const navigate = useNavigate();

  // Check if this is a chunk loading error
  const isChunkError =
    error?.message?.includes('Failed to fetch dynamically imported module') ||
    error?.message?.includes('Importing a module script failed') ||
    error?.message?.includes('error loading dynamically imported module');

  if (isChunkError) {
    return (
      <div className="flex h-screen items-center justify-center bg-white">
        <div className="flex flex-col items-center space-y-6 p-8">
          <h2 className="text-3xl font-semibold text-center">New Version Available</h2>
          <p className="text-muted-foreground text-center text-m">
            We've updated the app! Please reload to get the latest version.
            <br />
          </p>
          <div className="flex gap-4">
            <Button onClick={() => window.location.reload()} className="px-6 py-2">
              Reload Page
            </Button>
            <Button onClick={() => navigate(-1)} variant="outline" className="px-6 py-2">
              Go Back
            </Button>
          </div>
        </div>
      </div>
    );
  }
  throw error;
}
